angular.module('impactx.login').controller('OpenIdStartpageCtrl', OpenIdStartpageCtrl);

OpenIdStartpageCtrl.$inject = ['LoginService', '$securityManager', '$routeParams', 'dataGen', 'OpenIdService', 'DeeplinkService'];

function OpenIdStartpageCtrl(LoginService, $securityManager, $routeParams, dataGen, OpenIdService, DeeplinkService) {
    var token = $routeParams.token;
    $securityManager.setToken(token);
    var osuTan = DeeplinkService.getRecentOsuTan();
    if (osuTan) {
        DeeplinkService.deleteRecentOsuTan();
    }
    LoginService.refreshUI(true, osuTan);
}